import Swiper from 'swiper'
import { isSwiperInitialize } from './_helpers'
import { cssAnimationAttr, loadedClass } from './_constants'
import { cssAnimationObserver } from './index'

export default function initTabContent(activeTab) {
  if (!activeTab) {
    return
  }

  const gallerySwiper = activeTab.querySelector('[data-tab-swiper="gallery"]')

  if (gallerySwiper && !isSwiperInitialize(gallerySwiper)) {
    new Swiper(gallerySwiper, {
      speed: 500,
      spaceBetween: 152,
      slidesPerView: 1,
      keyboard: true,
      observer: true,
      observeParents: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
        loadOnTransitionStart: true,
      },
      preloadImages: false,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1.35,
          spaceBetween: 12,
        },
        620: {
          slidesPerView: 1.1,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 64,
        },

        1024: {
          slidesPerView: 1,
          spaceBetween: 152,
        },
      },
    })
  }

  activeTab.querySelectorAll(cssAnimationAttr).forEach(el => {
    el.classList.add('disable-transition')
    el.classList.remove(loadedClass)
    setTimeout(() => {
      cssAnimationObserver.observe(el)
      el.classList.remove('disable-transition')
    }, 0)
  })
}
